import {IFormGroup} from '@core/api/data-access';
import {IBaseStore} from '@global-data';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';

export const formGroupAdapter: EntityAdapter<IFormGroup> = createEntityAdapter<IFormGroup>({
	selectId: (fg: IFormGroup) => {
		return fg?.erpId;
	},
});

export namespace FormGroupStore {
	/* ------------ Groups Structure ------------ */
	export type IFormGroupsState = EntityState<IFormGroup> &
		IBaseStore & {
			error: {error: string};
		};

	/* ------------ Groups Initial State ------------ */
	export const formGroupInitialState: IFormGroupsState = formGroupAdapter.getInitialState({
		loading: false,
		loaded: false,
		error: undefined,
	});
}
